export const NameAddress = '0x0836Cb07da51a8d3383275BBD2C9B6F02dA019B0'; // Name address
export const walletAddress = '0x9A84da3EF2145Af8dCA02379Aa934e6F859fcB23'; // wallet contract address

export const AirToken = '0x0eCEB4cd5087e477dc068a7B5694EB0fc74FA079'; //air token address
export const faucetAddress = '0x28B895306897C980635a85ba5a0904eaC197875f'; // faucet contract address

// NFT module
export const NFTAddress = '0x08Ce862841D41ECcb8550e0D2F890b176A65b74a';
export const MarketAddress = '0x37b688250769aa73E7F402b516D3fc2337126138';

// Swap module
export const WaterToken = '0xec3AAda0cda38F75701B2493c468a3815329561F';
export const WaterfaucetAddr = '0x5daa8f36008f08A54C21b937E949aD8fEe02cC2C';
export const SwapAddress = '0xD7FAa403606f93D2244484b16DCC901B7d48fCE9';
